import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb55cb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto ke-hoach-nam-form-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = {
  key: 0,
  class: "danh-muc-toa-xe-search-autocomplete-status"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_10 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_11 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_12 = { class: "flex justify-center gap-x-1" }
const _hoisted_13 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DinhMucCoDinhTable = _resolveComponent("DinhMucCoDinhTable")!
  const _component_KeHoachNamTable = _resolveComponent("KeHoachNamTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.rules,
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.submit(false)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Chọn chi nhánh")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        prop: "id_don_vi"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.id_don_vi,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.id_don_vi) = $event)),
                            class: "w-full",
                            filterable: "",
                            name: "id_don_vi",
                            placeholder: "Chọn chi nhánh",
                            disabled: _ctx.isUnitLevel,
                            onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.id_don_vi = 0))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                disabled: "",
                                label: "Chọn dữ liệu",
                                value: 0
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chiNhanhItems, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  value: item.id,
                                  label: item.ten_don_vi
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Số văn bản")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        prop: "so_van_ban"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            ref: "soVanBanInputRef",
                            modelValue: _ctx.form.so_van_ban,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.so_van_ban) = $event)),
                            placeholder: "Số văn bản",
                            name: "so_van_ban",
                            onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ngày ban hành")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        prop: "ngay_ban_hanh"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.ngay_ban_hanh,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.ngay_ban_hanh) = $event)),
                            "allow-before-global-min": "",
                            class: "w-100",
                            placeholder: "Ngày ban hành",
                            name: "ngay_ban_hanh",
                            format: "DD/MM/YYYY"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Năm")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_input, {
                        class: "w-full",
                        "model-value": _ctx.workingYear,
                        disabled: "",
                        name: "nam"
                      }, null, 8, ["model-value"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Chọn nhóm toa xe")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "id_danh_muc_toa_xe",
                        class: "mb-0 w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_autocomplete, {
                            ref: "danhMucToaXeAutocompleteRef",
                            modelValue: _ctx.tenDanhMucToaXe,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tenDanhMucToaXe) = $event)),
                            class: "w-full",
                            clearable: "",
                            "hide-loading": "",
                            placeholder: "Nhập để tìm kiếm ...",
                            name: "id_danh_muc_toa_xe",
                            "popper-class": "danh-muc-toa-xe-search-autocomplete-popper",
                            "trigger-on-focus": true,
                            "fetch-suggestions": _ctx.queryDanhMucToaXe,
                            "highlight-first-item": "",
                            onClear: _ctx.onClearDanhMucToaXe,
                            onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select())),
                            onSelect: _ctx.onSelectDanhMucToaXe
                          }, {
                            default: _withCtx(({ item }) => [
                              (item.__loading || item.__empty)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.ten_danh_muc), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.ten_danh_muc) + " - (" + _toDisplayString(item.ma_danh_muc) + ")", 1))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "fetch-suggestions", "onClear", "onSelect"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Chọn cấp sửa chữa")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "cap_sua_chua_id",
                        class: "mb-0 w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.cap_sua_chua_id,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.cap_sua_chua_id) = $event)),
                            class: "w-full",
                            name: "cap_sua_chua_id",
                            placeholder: "Chọn cấp sửa chữa",
                            onClear: _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.cap_sua_chua_id = 0))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                disabled: "",
                                label: "Chọn dữ liệu",
                                value: 0
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capSuaChuaItems, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  value: item.id,
                                  label: item.ten_cap_sc
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_LabelCustom, { isRequired: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Số lượng toa xe")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        prop: "so_luong_toa_xe"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: _ctx.form.so_luong_toa_xe,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.so_luong_toa_xe) = $event)),
                            class: "w-full",
                            min: 1,
                            precision: 0,
                            step: 1,
                            name: "so_luong_toa_xe",
                            "controls-position": "right",
                            onFocus: _cache[10] || (_cache[10] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ghi chú")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "ghi_chu",
                        class: "mb-0 w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.ghi_chu,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.ghi_chu) = $event)),
                            placeholder: "Ghi chú",
                            name: "ghi_chu",
                            type: "textarea",
                            autosize: { minRows: 1 },
                            resize: "none",
                            onFocus: _cache[12] || (_cache[12] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.isCreating)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 0,
                    classes: `rounded-none m-0`,
                    "button-type": _ctx.ButtonsType.ADD,
                    "color-type": _ctx.ButtonTypeColors.PRIMARY,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submit(false)))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Lưu và tiếp tục")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ButtonCustom, {
                classes: `rounded-none m-0`,
                "button-type": _ctx.ButtonsType.SAVE,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submit(true)))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Lưu")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"]),
              _createVNode(_component_ButtonCustom, {
                classes: `rounded-none m-0`,
                "color-type": _ctx.ButtonTypeColors.WARNING,
                "button-type": _ctx.ButtonsType.REFRESH,
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearForm(true)))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Nhập lại")
                ]),
                _: 1
              }, 8, ["color-type", "button-type"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        (_ctx.dinhMucCoDinhDetail)
          ? (_openBlock(), _createBlock(_component_DinhMucCoDinhTable, {
              key: 0,
              items: [_ctx.dinhMucCoDinhDetail]
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_KeHoachNamTable, {
            "cur-page": _ctx.currentPage,
            items: _ctx.keHoachItems,
            "per-page": _ctx.perPage
          }, null, 8, ["cur-page", "items", "per-page"]),
          (_ctx.totalItems > 0)
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 0,
                page: _ctx.currentPage,
                "page-size": _ctx.perPage,
                total: _ctx.totalItems,
                onChangePage: _cache[17] || (_cache[17] = (value) => (_ctx.currentPage = value)),
                onChangePageSize: _cache[18] || (_cache[18] = (value) => (_ctx.perPage = value))
              }, null, 8, ["page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}